function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => React.createElement("svg", _extends({
  width: "100",
  height: "100",
  xmlns: "http://www.w3.org/2000/svg"
}, props), React.createElement("title", null, "icon-external-link"), React.createElement("g", {
  id: "icon-link-icon-external-link",
  stroke: "none",
  strokeWidth: "1",
  fill: "none",
  fillRule: "evenodd"
}, React.createElement("path", {
  d: "M10.0959421,26.8976843 L10.0959421,88.951403 L72.6896286,88.951403 L72.6896286,54.2915111 L82.7855707,54.2915111 L82.7855707,99.0473452 L0,99.0473452 L0,16.8017422 L45.0949705,16.8017422 L45.0949705,26.8976843 L10.0959421,26.8976843 Z M43.3952914,50.2335313 L82.1553012,11.4735215 L59.215674,11.2730766 L59.1247618,1 L99.6385682,1.36143158 L100,41.8752677 L89.7267156,41.7840897 L89.5262709,18.8444913 L50.7662612,57.6045011 L43.3952914,50.2335313 Z",
  id: "icon-link-Combined-Shape",
  fill: "#000",
  fillRule: "nonzero"
}))));